import { ICON_BASE_PATH } from "@/app/utils/config";
import "./AuthMatrix.scss";

interface ContentTitleProps {
  id?: string;      
  label: string;
}

const ICON_MAP: Record<string, string> = {
  "182": "cash-icon.svg",
  "183": "earth-icon.svg",
  "184": "bank-icon.svg",
  "185": "earth-icon.svg",
  "186": "earth-icon.svg",
  "187": "earth-icon.svg",
  "188": "bill-icon.svg",
  "189": "credit-card-icon.svg",
  "190": "payer.svg",
  "191": "payer.svg",
  "193": "loan.svg",
  "194": "bulk-fileuploadblack.svg",
  default: "authorize-icon.svg",
};

export const ContentTitle = ({ id, label }: ContentTitleProps) => {
  // pick icon based on paymentTypeId
  const iconFile = id && ICON_MAP[id] ? ICON_MAP[id] : ICON_MAP.default;

  return (
    <>
      <div className="gx-content-title">
        <div className="gx-content-title-container">
          {/* <div className="gx-content-title-icon-wrapper">
            <img
              src={`${ICON_BASE_PATH}${iconFile}`}
              alt={`${label} icon`}
              className="gx-icon-primary"
            />
          </div> */}
          <p className="gx-p20-sb">{label}</p>
        </div>
      </div>
      <hr className="gx-content-title-divider" />
    </>
  );
};